export function getSlideByPage(page: number) {
  return page < 36 ? page - 1 : page - 36
}
